import { Responses } from '@consta/uikit/Responses'
import { ResponsesImageNothingFound } from '@consta/uikit/ResponsesImageNothingFound'
import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

export const ResponsesNothingFound: FC = () => (
  <Responses
    title={
      <Text weight="medium" lineHeight="xs" view="primary">
        Ничего не найдено :(
      </Text>
    }
    description={
      <Text as="span" size="s" view="secondary">
        Попробуйте другой запрос
      </Text>
    }
    image={ResponsesImageNothingFound}
  />
)
